export function saveToSession<T>(key: string, value: T): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.warn(`Error saving "${key}" to session storage:`, error)
  }
}

export function loadFromSession<T>(key: string): T | null {
  const raw = sessionStorage.getItem(key)
  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

export function removeFromSession(key: string): void {
  sessionStorage.removeItem(key)
}
